import { render, staticRenderFns } from "./BaseFormMessage.vue?vue&type=template&id=c5cf426e"
import script from "./BaseFormMessage.vue?vue&type=script&lang=js"
export * from "./BaseFormMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports